<template>
  <div class="update-password-wrapper">
    <div class="title">修改密码</div>
    <a-form-model
      :model="passwordForm"
      ref="passwordForm"
      :rules="rules"
      class="login-form"
    >
      <a-form-model-item prop="password">
        <a-input-password
          :size="formSize"
          v-model.trim="passwordForm.password"
          type="password"
          placeholder="密码必须6-18个字符，且同时包含字母和数字"
        >
          <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
        </a-input-password>
      </a-form-model-item>
      <a-form-model-item prop="confirmPassword">
        <a-input-password
          :size="formSize"
          v-model.trim="passwordForm.confirmPassword"
          type="password"
          placeholder="确认密码"
        >
          <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
        </a-input-password>
      </a-form-model-item>
      <a-form-model-item>
        <a-button
          block
          type="primary"
          :size="formSize"
          @click="handleSubmit"
          :loading="loading"
        >
          确定
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { updatePassWord } from "@/api/user";
import { showMessage } from "@/utils/message";

export default {
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (!/^(?=.*[a-zA-Z])(?=.*\d)[^]{6,18}$/.test(value)) {
        callback(new Error("密码必须6-18个字符，且同时包含字母和数字"));
      } else {
        if (this.passwordForm.confirmPassword !== "") {
          this.$refs.passwordForm.validateField("confirmPassword");
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入确认密码"));
      } else if (value !== this.passwordForm.password) {
        callback(new Error("两次输入的密码不一致"));
      } else if (!/^(?=.*[a-zA-Z])(?=.*\d)[^]{6,18}$/.test(value)) {
        callback(new Error("密码必须6-18个字符，且同时包含字母和数字"));
      } else {
        callback();
      }
    };
    return {
      passwordForm: {
        password: "",
        confirmPassword: ""
      },
      rules: {
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur"
          }
        ],
        confirmPassword: [
          {
            required: true,
            validator: validatePass2,
            trigger: "blur"
          }
        ]
      },
      canSendCode: false,
      codeText: "获取验证码",
      loading: false,
      codeLoading: false
    };
  },
  computed: {
    ...mapGetters(["formSize"])
  },
  methods: {
    ...mapActions({
      logout: "Logout"
    }),
    handleSubmit() {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          this.loading = true;
          updatePassWord(this.passwordForm)
            .then(async () => {
              showMessage("success", "密码修改成功");
              await this.logout();
              this.$router.replace({ name: "Login" });
            })
            .catch(e => {
              console.error(e);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.update-password-wrapper {
  min-height: 380px;
  .title {
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    width: 365px;
    margin: 0 auto 20px;
  }

  .login-form {
    width: 375px;
    padding: 0 5px;
    box-sizing: border-box;
    margin: 0 auto;
  }
}
</style>
